// Persistent anonymous visitor ID shared by all community features
export const getVisitorId = () => {
  let id = localStorage.getItem('slt_browser_id');
  if (!id) {
    id = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem('slt_browser_id', id);
  }
  return id;
};
